import {
    Autocomplete,
    Box,
    Button,
    Card,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    Stack,
    Switch,
    TextField,
    Typography } from "../../ui";
import React,
    { useCallback,
    useEffect,
    useMemo,
    useState } from "react";
import ThreeDText from "../../global/ThreeDText";
import {
  BackenedConstant,
  getAuthSession,
  CartDets,
  CUSTOMERAPP,
  GETSINGLECONFIGS,
  getPreUrlAccordingToCart,
  isEmpty,
  isFeatureAllowed,
  isNumberEmpty,
  isRoleAllowed,
  ItemCondtion,
  ItemStatus,
  local_test_url,
  PersonType,
  printDebugLog,
  PRODUCT_IMAGE_MAX_UPLOAD_SIZE_MB,
  SizeType,
  STOCKMGMT,
  SUCCESS,
  ROLE_VIEW
} from "../../../constants/constant";
import { INITIAL_CATEOGORY_ITEM, INITIAL_COLOR_MODEL, INITIAL_CONVERSION_SINGLE_DATA, 
    INITIAL_INVENTORY_DETAILS, INITIAL_PRODUCT_INFO } from "../productConstant";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DeleteIcon from '../../ui/icons/Delete';
import uiUtilInstance from "../../../utilities/uiUtil";
import SnpButton from "../../global/SnpButton";
import DismissButton from "../../global/DismissButton";
import imageUploadService from "../../../service/imageUploadService";
import { snpAxios } from "../../global/api";
import FileUploadIcon from '../../ui/icons/FileUpload';
import AboutItemEditor from "./AboutItemEditor";
import { richTextValueToPlainText } from "./richTextUtils";

const DEFAULT_PRODUCT_IMAGE_MAX_UPLOAD_SIZE_MB = 5;
const BYTES_PER_MB = 1024 * 1024;

const getValidImageUploadLimit = (value) => {
    const parsedValue = Number(value);
    return Number.isFinite(parsedValue) && parsedValue > 0
        ? parsedValue
        : DEFAULT_PRODUCT_IMAGE_MAX_UPLOAD_SIZE_MB;
};

const formatMegabytes = (bytes) => (bytes / BYTES_PER_MB).toFixed(2);

const readImageAsDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error(`Could not preview ${file.name}.`));
    reader.readAsDataURL(file);
});

const getImageUploadErrorMessage = (error) => {
    const responseData = error?.response?.data;
    const responseMessage = typeof responseData === "string"
        ? responseData
        : responseData?.message || responseData?.error;
    return responseMessage
        || error?.message
        || (error?.response?.status ? `Upload failed (HTTP ${error.response.status}).` : "Upload failed.");
};

const AddProduct = ({ showSnackbar, snpLoader, setSnpLoader, showDialog, closeDialog, dialogConfig, productProps = {} }) => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();

    const [inputValue, setInputValue] = useState('');
    const [listProduct, setListProduct] = useState([]);
    const [listComposition, setListComposition] = useState([]);
    const [inputUsageValue, setInputUsageValues] = useState('');
    const [listStockUsage, setListStockUsage] = useState([]);
    const [inputSideEffects, setInputSideEffects] = useState('');
    const [listSideEffects, setListSideEffects] = useState([]);

    const [listBrandName, setListBrandName] = useState([]);
    const [listHsnCode, setListHsnCode] = useState([]);

    const [inputListINvetory, setInputListInventory] = useState('');
    const [listInventory, setListInventory] = useState([]);

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [productInfo, setProductInfo] = useState(INITIAL_PRODUCT_INFO);
    const [aboutItemEditorOpen, setAboutItemEditorOpen] = useState(false);
    const [selectedCategory, setSelectedcategory] = useState(INITIAL_CATEOGORY_ITEM);

    const [inventoryDetails, setInventoryDetails] = useState(INITIAL_INVENTORY_DETAILS);
    const [conversionSingleData, setConversionSingleData] = useState(INITIAL_CONVERSION_SINGLE_DATA);
    const [createUnit, setCreateUnit] = useState(false);

    const [listColor, setListColor] = useState([]);
    const [color, setColor] = useState(INITIAL_COLOR_MODEL);

    const [listDialColor, setListDialColor] = useState([]);
    const [dialColor, setDialColor] = useState(INITIAL_COLOR_MODEL);

    const [imageSelectedError, setImageSelectedError] = useState("");
    const [imageUploadLimitMb, setImageUploadLimitMb] = useState(DEFAULT_PRODUCT_IMAGE_MAX_UPLOAD_SIZE_MB);
    const [uploadedDocument, setUploadedDocument] = useState([]);
    const [selectedImage, setSelectedImage] = useState([]);
    const [existingImageSizes, setExistingImageSizes] = useState({});
    const [existingImageSizeLoading, setExistingImageSizeLoading] = useState(false);
    const [existingImageSizeError, setExistingImageSizeError] = useState("");

    const existingProductImages = useMemo(
        () => Array.isArray(inventoryDetails.productImage)
            ? inventoryDetails.productImage.filter(Boolean)
            : [],
        [inventoryDetails.productImage]
    );
    const existingImageBytes = existingProductImages.reduce(
        (total, imagePath) => total + (existingImageSizes[imagePath] || 0),
        0
    );
    const pendingImageBytes = uploadedDocument.reduce((total, file) => total + (file?.size || 0), 0);
    const selectedImageBytes = existingImageBytes + pendingImageBytes;
    const imageUploadLimitBytes = imageUploadLimitMb * BYTES_PER_MB;
    const remainingImageUploadMb = Math.max(0, imageUploadLimitBytes - selectedImageBytes);
    const isImageUploadFull = !existingImageSizeLoading && selectedImageBytes >= imageUploadLimitBytes;

    const [suggestedItem, setSuggestedItem] = useState([]);
    const [suggestedItemDeleted, setSuggestedItemDeleted] = useState([]);
    const [suggestionAvail, setSuggAvail] = useState(false);
    const [itemData, setItemData] = useState([]);

    const [subCatgList, setSubCatgList] = useState([]);

    const [createNewProduct, setCreateProduct] = useState(false);
    const [createNewInventory, setCreateNewInventory] = useState(false);


    const fireSnackBarMsg = ({ msg, mHorizontal = "right", mVertical = "top", mColor = "#008b8b" }) => {
        showSnackbar(msg, mColor, mVertical, mHorizontal);
    };

    const showImageLimitDialog = (message) => {
        showDialog({
            ...dialogConfig,
            title: "Product image limit",
            subTitle: message,
            negativeReq: true,
            negativeAction: "OK",
            positiveReq: false,
            outSideClickDismiss: false,
            cancelExtra: true,
            handleClose: closeDialog,
        });
    };

    const handleInputChangeValue = (event) => {
        if (event) {
            //printDebugLog("handleInputChangeValue",event.target.value)
            setInputValue(event.target.value);
        }
    };

    const handleInputListInventory = (event) => {
        if (event) {
            //printDebugLog("handleInputChangeValue",event.target.value)
            setInputListInventory(event.target.value);
        }
    };

    const isValid = () => {
        let isproductInfoValid = true;
        if (!productInfo.prdName || !productInfo.brandName) {
            isproductInfoValid = false;
        }
        return isproductInfoValid;
    }

    const handleSearch = (event) => {
        const value = event.target.value;
        if (value.length >= 3) {
            getProductItemDetails(value);
        }
    };

    const handleProductChange = (event) => {
        const { name, value } = event.target;
        printDebugLog("AddProduct:handleProductChange", name, value);
        setProductInfo(prev => ({
            ...prev, [name]: value,
        }));
    };



    const handleInventoryChange = (event) => {
        const { name, value } = event.target;
        printDebugLog("AddProduct:handleInventoryChange", name, value);
        if (name === "imgPath") {
            const imageList = Array.from(event.target.files || []);
            printDebugLog("imgPath=>", imageList);

            if (existingImageSizeLoading) {
                setImageSelectedError("Please wait while the current image sizes are calculated.");
                event.target.value = "";
                return;
            }
            if (existingImageSizeError) {
                setImageSelectedError(existingImageSizeError);
                event.target.value = "";
                return;
            }
            if (isImageUploadFull) {
                showImageLimitDialog(
                    `Image limit is full (${formatMegabytes(selectedImageBytes)} MB of ${imageUploadLimitMb} MB used). Delete an image before adding another.`
                );
                event.target.value = "";
                return;
            }

            if (imageList.length > 0) {
                const invalidFiles = imageList.filter((file) => !file.type?.startsWith("image/"));
                if (invalidFiles.length > 0) {
                    setImageSelectedError("Only image files, including GIF images, can be uploaded.");
                    event.target.value = "";
                    return;
                }

                const incomingImageBytes = imageList.reduce((total, file) => total + file.size, 0);
                const newTotalImageBytes = selectedImageBytes + incomingImageBytes;
                if (newTotalImageBytes > imageUploadLimitBytes) {
                    showImageLimitDialog(
                        `Current and selected images total ${formatMegabytes(newTotalImageBytes)} MB. The configured maximum is ${imageUploadLimitMb} MB.`
                    );
                    event.target.value = "";
                    return;
                }

                setImageSelectedError("");

                Promise.all(imageList.map(readImageAsDataUrl))
                    .then((newImages) => {
                        setUploadedDocument((prev) => [...(prev || []), ...imageList]);
                        setSelectedImage((prev) => [...(prev || []), ...newImages]);
                    })
                    .catch((error) => setImageSelectedError(error.message));
                event.target.value = "";
            } else {
                setImageSelectedError("Please select at least one image.");
            }
        } else if (name === 'waterResistance') {
            const previousCheckedValue = inventoryDetails.waterResistance;
            setInventoryDetails(prev => ({
                ...prev, waterResistance: !previousCheckedValue,
            }));
        }
        else {
            setInventoryDetails(prev => ({
                ...prev, [name]: value,
            }));
        }
    };

    const handleSelectChange = (event, catg) => {
        //console.log("handleSelectChange", catg);
        if (catg !== null) {
            setSelectedcategory(catg);
        } else {
            setSelectedcategory(productProps.selectedCategory ?? INITIAL_CATEOGORY_ITEM);
        }
    };

    const handleSelectProduct = (event, row) => {
        if (row !== null) {
            if (isEmpty(row.prdId)) {
                printDebugLog("handleSelectProduct ", event.target.name, row);
                setProductInfo(prev => ({
                    ...prev,
                    [event.target.name]: row,
                }))
            } else {
                setProductInfo({
                    prdId: row.prdId, prdName: row.prdName,
                    brandName: row.brandName, hsnCode: row.hsnCode, rack_no: row.rack_no,
                    composition: row.composition ?? [], stockUsage: row.stockUsage ?? [],
                    stockSideEffects: row.stockSideEffects ?? [], stockStorage: row.stockStorage,
                    itemStatus: row.itemStatus, aboutItem: row.aboutItem,
                });
            }
        } else {
            setProductInfo(INITIAL_PRODUCT_INFO);
        }
    }

    const handleSelectProductChild = (name, row) => {
        printDebugLog("handleSelectProductChild", name + "->" + row);
        if (row !== null) {
            setProductInfo(prev => ({
                ...prev,
                [name]: row,
            }))
        } else {
            setProductInfo(prev => ({
                ...prev,
                [name]: "",
            }))
        }
    }

    const handleSelectComposition = (event, newValue, reason, detail) => {
        printDebugLog("Autocomplete", event.key, newValue, reason, detail);
        setInputValue('');
        if (reason === 'removeOption') {
            setProductInfo(prev => ({
                ...prev,
                composition: prev.composition.filter(i => i !== detail.option),
            }));
        } else if (reason === 'selectOption' || reason === 'createOption') {
            setProductInfo((prev) => ({
                ...prev,
                composition: newValue,
            }));
        } else if (reason === 'clear') {
            setProductInfo((prev) => ({
                ...prev,
                composition: [],
            }));
        }
    };

    const handleItemSearchChange = (event) => {
        if (event) {
            if (event.target.name === 'composearch') {
                setInputValue(event.target.value);
            } else if (event.target.name === 'usagesearch') {
                setInputUsageValues(event.target.value);
            } else if (event.target.name === 'effectsearch') {
                setInputSideEffects(event.target.value);
            }
        }
    };

    const handleKeyDownComposition = (evt) => {
        printDebugLog("handleKeyDownComposition key", evt?.key);
        if (["Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            printDebugLog("handleKeyDownComposition inputValue", inputValue);
            if (!isEmpty(inputValue)) {
                setListComposition([]);
                const list = productInfo.composition === undefined ? [inputValue] : [...productInfo.composition, inputValue];
                setProductInfo(prev => ({
                    ...prev,
                    composition: list,
                }));
                setInputValue('');
            }
        }
    };

    const handleKeyDownUsage = (evt) => {
        printDebugLog("handleKeyDownUsage", evt?.key);
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            printDebugLog("handleKeyDownUsage inputValue", inputUsageValue);
            if (!isEmpty(inputUsageValue)) {
                setListStockUsage([]);
                setProductInfo(prevs => ({
                    ...prevs,
                    stockUsage: prevs.stockUsage === undefined ? [inputUsageValue] : [...prevs.stockUsage, inputUsageValue],
                }));
                setInputUsageValues('');
            }
        }
    };

    const handleKeyDownSideEffect = (evt) => {
        printDebugLog("handleKeyDownSideEffect", evt?.key);
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            printDebugLog("handleKeyDownSideEffect inputValue", inputSideEffects);
            if (!isEmpty(inputSideEffects)) {
                setListSideEffects([]);
                setProductInfo(prevs => ({
                    ...prevs,
                    stockSideEffects: prevs.stockSideEffects === undefined ? [inputSideEffects] : [...prevs.stockSideEffects, inputSideEffects],
                }));
                setInputSideEffects('');
            }
        }
    };

    const handleSelectUsage = (event, newValue, reason, detail) => {
        printDebugLog("Autocomplete", newValue, reason, detail);
        setInputUsageValues('');
        if (reason === 'removeOption') {
            setProductInfo(prev => ({
                ...prev,
                stockUsage: prev.stockUsage.filter(i => i !== detail.option),
            }));
        } else if (reason === 'selectOption' || reason === 'createOption') {
            setProductInfo((prev) => ({
                ...prev,
                stockUsage: newValue,
            }));
        } else if (reason === 'clear') {
            setProductInfo((prev) => ({
                ...prev,
                stockUsage: [],
            }));
        }
    };

    const handleSelectSideEffect = (event, newValue, reason, detail) => {
        printDebugLog("Autocomplete", newValue, reason, detail);
        setInputSideEffects('');
        if (reason === 'removeOption') {
            setProductInfo(prev => ({
                ...prev,
                stockSideEffects: prev.stockSideEffects.filter(i => i !== detail.option),
            }));
        } else if (reason === 'selectOption' || reason === 'createOption') {
            setProductInfo(prev => (
                {
                    ...prev,
                    stockSideEffects: newValue,
                }
            ));
        } else if (reason === 'clear') {
            setProductInfo(prev => (
                {
                    ...prev,
                    stockSideEffects: [],
                }
            ));
        }
    };

    const handleSearchComposition = (event) => {
        const { name, value } = event.target;
        //printDebugLog("handleSearchComposition", name);
        if (value.length >= 3) {
            fetchAutoCompleteDetails(name, value);
        }
    };

    const handleSearchHsnCodeBrandName = (event, length) => {
        const { name, value } = event.target;
        printDebugLog("handleSearchHsnCodeBrandName", name, value, productInfo);
        setProductInfo(prev => ({
            ...prev,
            [name]: value,
        }))
        //printDebugLog("handleSearchComposition", name);
        if (value.length >= length) {
            fetchAutoCompleteDetails(name, value);
        }
    };

    const handleSearchColor = (event) => {
        const { name, value } = event.target;
        printDebugLog("handleSearchColor", name);
        if (value.length >= 3) {
            fetchAutoCompleteDetails(name, value);
        }
    };

    const handleConversionChange = (event, option) => {
        if (option != null) {
            // console.log("handleConversionChange", option);
            if (option.id === "cr") {
                setConversionSingleData(INITIAL_CONVERSION_SINGLE_DATA);
                setCreateUnit(true);
            } else {
                if (createUnit)
                    setCreateUnit(false);
                setConversionSingleData(option);
            }
        } else {
            setCreateUnit(false);
            setConversionSingleData(option);
        }
    };

    const handleInventorySelect = (ev, option) => {
        if (option !== null) {
            getInventoryDeleteStatus(option);
            setInputListInventory("");
        }
    };

    const buildInventory = (payLoad, allowedDelete = true) => {
        printDebugLog("buildInventory:", payLoad, allowedDelete);
        setColor(prev => ({
            ...prev,
            colorId: payLoad.colorId,
            colorDetails: payLoad.colorDetails,
        }));
        setDialColor(prev => ({
            ...prev,
            colorId: payLoad.dialColorId,
            colorDetails: payLoad.dialColorDetails,
        }))
        setConversionSingleData(prev => ({
            ...prev,
            id: payLoad.cnvId,
            cnvDetails: payLoad.cnvDetails,
        }));
        setInventoryDetails(prev => ({
            ...prev,
            sizeType: payLoad.sizeType,
            personType: payLoad.personType,
            allowedDelete: allowedDelete,
            productImage: payLoad.productImage,
            id: payLoad.id,
            itemStatus: Number(payLoad.invStatus),
            condition: payLoad.condition, caseSize: payLoad.caseSize, lugWidth: payLoad.lugWidth,
            jewels: payLoad.jewels, caseMetal: payLoad.caseMetal,
            waterResistance: payLoad.waterResistance, movementType: payLoad.movementType,
        }));

    };

    const handleCoversionUpdate = (event) => {
        const { name, value } = event.target;
        //console.log("handleCoversionUpdate", name, value);
        if (name === 'unitRestrictions') {
            const previousCheckedValue = conversionSingleData.unitRestrictions;
            setConversionSingleData(prev => ({
                ...conversionSingleData,
                unitRestrictions: !previousCheckedValue,
            }));
        } else if (name === 'decimalSmRestrictions') {
            const previousCheckedValue = conversionSingleData.decimalSmRestrictions;
            setConversionSingleData(prev => ({
                ...conversionSingleData,
                decimalSmRestrictions: !previousCheckedValue,
            }));
        } else if (name === 'smallUnitCount') {
            if (/^[0-9]*\.?[0-9]*$/.test(value)) {
                setConversionSingleData(prev => ({
                    ...conversionSingleData,
                    smallUnitCount: value,
                }));
            }
        } else {
            if (value === "" || /^[a-zA-Z]*$/.test(value)) {
                setConversionSingleData(prev => ({
                    ...conversionSingleData,
                    [name]: value,
                }));
            }
        }
    };

    const handleDeleteInternalImage = (index) => {
        printDebugLog("handleDeleteInternalImage", index);
        setImageSelectedError("");
        setSelectedImage((prev) => prev.filter((_, i) => i !== index));
        setUploadedDocument((prev) => prev.filter((_, i) => i !== index));
    };

    const getProductImageUploadLimit = async () => {
        try {
            const configUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}${GETSINGLECONFIGS}?adminId=${getAuthSession().apiToken}&configName=${encodeURIComponent(PRODUCT_IMAGE_MAX_UPLOAD_SIZE_MB)}&shopHash=${storeActiveShopHash.id}`;
            const response = await axios.get(configUrl);
            setImageUploadLimitMb(getValidImageUploadLimit(response.data));
        } catch (error) {
            console.error("getProductImageUploadLimit", error);
            setImageUploadLimitMb(DEFAULT_PRODUCT_IMAGE_MAX_UPLOAD_SIZE_MB);
        }
    };

    const getExistingProductImageSize = useCallback(async (imagePath) => {
        const imageUrl = `${storeApiUrl.BACKEND_BASE_URL}files/${imagePath}`;
        try {
            const response = await axios.head(imageUrl);
            const contentLength = Number(response.headers?.["content-length"]);
            if (Number.isFinite(contentLength) && contentLength > 0) {
                return contentLength;
            }
        } catch (error) {
            printDebugLog("getExistingProductImageSize:HEAD", imagePath, error);
        }

        const response = await axios.get(imageUrl, { responseType: "blob" });
        const imageSize = response.data?.size || 0;
        if (imageSize <= 0) {
            throw new Error(`Could not determine the size of ${imagePath}.`);
        }
        return imageSize;
    }, [storeApiUrl.BACKEND_BASE_URL]);

    const handleSelectColorChange = (event, colorModel) => {
        //console.log("handleSelectColorChange", colorModel);
        if (colorModel !== null) {
            setColor(colorModel);
        } else {
            setColor(INITIAL_COLOR_MODEL)
        }
    };

    const handleDialColor = (event, colorModel) => {
        console.log("handleDialColor", colorModel);
        if (colorModel !== null) {
            setDialColor(colorModel);
        } else {
            setDialColor(INITIAL_COLOR_MODEL)
        }
    };

    const handleNewInvetory = () => {
        setInventoryDetails(INITIAL_INVENTORY_DETAILS);
        setColor(INITIAL_COLOR_MODEL);
        setCreateUnit(false);
        setConversionSingleData(INITIAL_CONVERSION_SINGLE_DATA);
        setSelectedImage([]);
        setUploadedDocument([]);
        setImageSelectedError("");
    };

    const getCateogoryInventoryType = async () => {
        try {
            const productDetails = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-some-types?cartType=${storeActiveShopHash.cartType}&type=${BackenedConstant.CATEOGORY_SUB_SECTION}`;
            const response = await axios.get(productDetails);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setSubCatgList(payLoad.typeList);
            } else {
                setSubCatgList([]);
            }
        } catch (error) {
            console.error("getCateogoryInventoryType error : ", error);
        }
    };

    const fetchAutoCompleteDetails = async (id, regextStr) => {
        const cartTypeStr = getPreUrlAccordingToCart(storeActiveShopHash.cartType);
        let urlType = "";
        const version = 2;
        if (id === 'composearch') {
            urlType = `search-composition?q=${regextStr}&m=${storeActiveShopHash.cartType}&v=${version}`;
        } else if (id === 'usagesearch') {
            urlType = `search-stock-usage?q=${regextStr}&m=${storeActiveShopHash.cartType}&v=${version}`;
        } else if (id === 'effectsearch') {
            urlType = `search-side-effects?q=${regextStr}&m=${storeActiveShopHash.cartType}&v=${version}`;
        } else if (id === 'search-color') {
            urlType = `fetch-color?color=${regextStr}`;
        } else if (id === 'dial-color') {
            urlType = `fetch-color?color=${regextStr}`;
        } else if (id === 'hsnCode') {
            urlType = `search-hsn-code?q=${regextStr}&m=${storeActiveShopHash.cartType}`;
        } else if (id === 'brandName') {
            urlType = `search-brand-name?q=${regextStr}&m=${storeActiveShopHash.cartType}`;
        }
        try {
            const fetchBillUrl = `${storeApiUrl.BACKEND_BASE_URL}${cartTypeStr}${urlType}`;
            const response = await axios.get(fetchBillUrl);
            printDebugLog("fetchAutoCompleteDetails   => ", regextStr, response.data);
            if (!isEmpty(response.data)) {
                if (id === 'composearch') {
                    setListComposition(response.data);
                } else if (id === 'usagesearch') {
                    setListStockUsage(response.data);
                } else if (id === 'effectsearch') {
                    setListSideEffects(response.data);
                } else if (id === 'search-color') {
                    if (response.data.status === SUCCESS) {
                        setListColor(response.data.jcJson.snpColorModelList);
                    } else {
                        setListColor([]);
                    }
                } else if (id === 'dial-color') {
                    if (response.data.status === SUCCESS) {
                        setListDialColor(response.data.jcJson.snpColorModelList);
                    } else {
                        setListDialColor([]);
                    }
                } else if (id === 'hsnCode') {
                    setListHsnCode(response.data);
                } else if (id === 'brandName') {
                    setListBrandName(response.data);
                }

            } else {
                if (id === 'composearch') {
                    setListComposition([]);
                } else if (id === 'usagesearch') {
                    setListStockUsage([]);
                } else if (id === 'effectsearch') {
                    setListSideEffects([]);
                } else if (id === 'search-color') {
                    setListColor([]);
                } else if (id === 'hsnCode') {
                    setListHsnCode([]);
                } else if (id === 'brandName') {
                    setListBrandName([]);
                }

            }

        } catch (error) {
            console.error("fetchAutoCompleteDetails errr ", error);
            if (id === 'composearch') {
                setListComposition([]);
            } else if (id === 'usagesearch') {
                setListStockUsage([]);
            } else if (id === 'effectsearch') {
                setListSideEffects([]);
            } else if (id === 'search-color') {
                setListColor([]);
            } else if (id === 'hsnCode') {
                setListHsnCode([]);
            } else if (id === 'brandName') {
                setListBrandName([]);
            }
        }
    };

    const handleDeleteImage = async (index) => {
        try {
            const path = inventoryDetails.productImage[index];
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}delete-image-mart-v2?productHash=${inventoryDetails.id}&path=${path}`;
            printDebugLog("handleDeleteImage<=", cUrl);
            setSnpLoader(true);
            const response = await axios.get(cUrl);
            if (response.data.status === SUCCESS) {
                if (index !== -1) {
                    const images = inventoryDetails.productImage;
                    const updatedItems = [...images.slice(0, index), ...images.slice(index + 1)];
                    setInventoryDetails(prev => ({
                        ...prev,
                        productImage: updatedItems,
                    }));
                    setImageSelectedError("");
                    fireSnackBarMsg({ msg: "Image removed successfull ... Updating Items" });
                    //productInfo.getProductDetails();
                }
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("handleDeleteImage", error);
            setSnpLoader(false);
        }
    };

    const getProductItemDetails = async (stock) => {
        try {
            const productDetails = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-product-name-v2?adminId=${getAuthSession().apiToken}&stock=${stock}&shopHash=${storeActiveShopHash.id}&type=${storeActiveShopHash.cartType}`;
            const response = await axios.get(productDetails);
            if (response.data.status === SUCCESS) {
                setItemData(response.data.jcJson.value_2);
            } else {
                setItemData([]);
            }
        } catch (error) {
            console.error("getProductItemDetails error : ", error);
        }
    };

    const getInventoryList = async (prdId) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}show-inventory-list?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&stock=${prdId}`;
            setSnpLoader(true);
            const response = await axios.get(cUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setListInventory(payLoad.fullData);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("getInventoryList", error);
            setSnpLoader(false);
        }
    };

    const getInventoryDeleteStatus = async (option) => {
        try {
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}check-inventory-delete-status?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&stock=${option.id}`;
            setSnpLoader(true);
            const response = await axios.get(cUrl);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                buildInventory(option, payLoad.allowedDelete);
            } else {
                buildInventory(option, false);
            }
            setSnpLoader(false);
        } catch (error) {
            console.error("getInventoryDeleteStatus", error);
            setSnpLoader(false);
            buildInventory(option, false);
        }
    };

    const handleSaveProduct = async (productImages = inventoryDetails.productImage || []) => {
        if (isEmpty(conversionSingleData.id) && !createUnit) {
            setSnpLoader(false);
            fireSnackBarMsg({ msg: "Custom Unit Type Cannot be empty" });
            return;
        }
        if (createUnit && !conversionSingleData.unitRestrictions && isNumberEmpty(conversionSingleData.smallUnitCount)) {
            setSnpLoader(false);
            fireSnackBarMsg({ msg: "Empty Small Count for Custom Unit" });
            return;
        }
        if (isEmpty(selectedCategory.catgId)) {
            setSnpLoader(false);
            fireSnackBarMsg({ msg: "Cateogory cannot be empty" });
            return;
        }
        setSnpLoader(true);
        setSelectedImage([]);
        setUploadedDocument([]);
        setImageSelectedError("");
        setFormSubmitted(false);
        let suggestionData = "";
        if (!isEmpty(suggestedItem)) {
            if (!isEmpty(suggestedItem)) {
                suggestionData = suggestedItem.map(item => item.id
                );
            }
        }
        const catgUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}persist-product-entry-v2`;
        const filledData = {
            jcJson: {
                apiToken: getAuthSession().apiToken,
                shopHash: storeActiveShopHash.id,
                prdId: productInfo.prdId,
                inventoryId: inventoryDetails.id,
                cnvId: conversionSingleData.id,
                catgId: selectedCategory.catgId,
                catgName: selectedCategory.catgName,
                composition: productInfo.composition,
                itemStatus: Number(productInfo.itemStatus),
                prdName: productInfo.prdName,
                brandName: productInfo.brandName,
                hsnCode: productInfo.hsnCode,
                rack_no: productInfo.rack_no,
                productImage: productImages,
                colorId: color.colorId,
                aboutItem: productInfo.aboutItem,
                unitName: conversionSingleData.unitName,
                smallUnitCount: parseFloat(conversionSingleData.smallUnitCount),
                unitCount: Number(conversionSingleData.unitCount),
                smallUnitName: conversionSingleData.smallUnitName,
                unitRestrictions: conversionSingleData.unitRestrictions,
                decimalSmRestrictions: conversionSingleData.decimalSmRestrictions,
                sizeType: inventoryDetails.sizeType,
                personType: inventoryDetails.personType,
                inventoryStatus: inventoryDetails.inventoryStatus,
                itemShortCode: productInfo.itemShortCode,
                stockSideEffects: productInfo.stockSideEffects,
                stockStorage: productInfo.stockStorage,
                stockUsage: productInfo.stockUsage,
                listItemSuggestion: suggestionData,
                delListItemSuggestion: suggestedItemDeleted,
                invStatus: Number(inventoryDetails.itemStatus),
                caseMetal: inventoryDetails.caseMetal,
                condition: inventoryDetails.condition,
                lugWidth: inventoryDetails.lugWidth,
                caseSize: inventoryDetails.caseSize,
                jewels: inventoryDetails.jewels,
                dialColorId: dialColor.colorId,
                waterResistance: inventoryDetails.waterResistance,
                movementType: inventoryDetails.movementType,
            }
        };
        //console.log("handleProductEntry => ", filledData);
        return snpAxios.post(
            catgUrl,
            filledData
        ).then(response => {
            printDebugLog("handleSaveProduct:responses => ", response.data);
            setSnpLoader(false);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveReq: true,
                    positiveAction: "Ok!",
                    handleSubmit: () => {
                        setProductInfo(prev => ({
                            ...prev, prdId: response.data.jcJson.prdId,
                        }))
                        closeDialog();
                        getInventoryList();
                    },
                    negativeAction: "Go back!", subTitle: "Records updated Successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });
            }
        }).catch(error => {
            console.error("handleSaveProduct : ", error);
            // window.location.href = "#/error";
            setSnpLoader(false);
        });
    };

    const uploadProductImageEntries = async (imageEntries, savedImagePaths) => {
        setSnpLoader(true);
        setImageSelectedError("");

        const results = await Promise.allSettled(imageEntries.map(async (entry) => {
            const formData = new FormData();
            formData.append("fnm", getAuthSession().apiToken);
            formData.append("file", entry.file);
            const response = await imageUploadService.upload(
                storeApiUrl.BACKEND_BASE_URL,
                getPreUrlAccordingToCart(storeActiveShopHash.cartType),
                formData
            );
            const uploadedPath = response.data?.folderName;
            if (!uploadedPath) {
                throw new Error("Server did not return the uploaded image path.");
            }
            return { ...entry, uploadedPath };
        }));

        const successfulEntries = [];
        const failedEntries = [];
        results.forEach((result, index) => {
            if (result.status === "fulfilled") {
                successfulEntries.push(result.value);
            } else {
                failedEntries.push({
                    ...imageEntries[index],
                    errorMessage: getImageUploadErrorMessage(result.reason),
                });
            }
        });

        const nextImagePaths = [
            ...savedImagePaths,
            ...successfulEntries.map((entry) => entry.uploadedPath),
        ];

        if (successfulEntries.length > 0) {
            setExistingImageSizes((previous) => {
                const nextSizes = { ...previous };
                successfulEntries.forEach((entry) => {
                    nextSizes[entry.uploadedPath] = entry.file.size;
                });
                return nextSizes;
            });
            setInventoryDetails((previous) => ({
                ...previous,
                productImage: nextImagePaths,
            }));
        }

        setUploadedDocument(failedEntries.map((entry) => entry.file));
        setSelectedImage(failedEntries.map((entry) => entry.preview));

        if (failedEntries.length === 0) {
            await handleSaveProduct(nextImagePaths);
            return;
        }

        setSnpLoader(false);
        showDialog({
            ...dialogConfig,
            title: `${failedEntries.length} image${failedEntries.length === 1 ? "" : "s"} failed to upload`,
            subTitle: successfulEntries.length > 0
                ? `${successfulEntries.length} image${successfulEntries.length === 1 ? " was" : "s were"} uploaded successfully.`
                : "No image was uploaded successfully in this attempt.",
            gui: (
                <Box sx={{ mt: 1, textAlign: "left", maxHeight: 220, overflowY: "auto" }}>
                    {failedEntries.map((entry, index) => (
                        <Typography
                            key={`${entry.file.name}-${entry.file.lastModified}-${index}`}
                            variant="body2"
                            color="#B42318"
                            sx={{ mb: 0.5, overflowWrap: "anywhere" }}
                        >
                            {`${entry.file.name}: ${entry.errorMessage}`}
                        </Typography>
                    ))}
                </Box>
            ),
            negativeReq: true,
            negativeAction: "Dismiss & save",
            positiveReq: true,
            positiveAction: "Try again",
            outSideClickDismiss: false,
            cancelExtra: true,
            handleClose: () => {
                closeDialog();
                setUploadedDocument([]);
                setSelectedImage([]);
                setImageSelectedError("");
                handleSaveProduct(nextImagePaths);
            },
            handleSubmit: () => {
                closeDialog();
                uploadProductImageEntries(failedEntries, nextImagePaths);
            },
        });
    };

    const handleImageUpload = async () => {
        setFormSubmitted(true);
        printDebugLog("handleImageUpload", productInfo);
        if (isEmpty(conversionSingleData.id) && !createUnit) {
            fireSnackBarMsg({ msg: "Custom Unit Type cannot be null" });
            return;
        }
        if (createUnit && !conversionSingleData.unitRestrictions && isNumberEmpty(conversionSingleData.smallUnitCount)) {
            fireSnackBarMsg({ msg: "Empty Small Count for Custom Unit" });
            return;
        }
        if (isEmpty(selectedCategory.catgId)) {
            fireSnackBarMsg({ msg: "Cateogory cannot be empty" });
            return;
        }
        if (!isValid()) {
            return;
        }
        if (existingImageSizeLoading) {
            setImageSelectedError("Please wait while the current image sizes are calculated.");
            return;
        }
        if (existingImageSizeError) {
            setImageSelectedError(existingImageSizeError);
            return;
        }
        const hasImagesToUpload = uploadedDocument && uploadedDocument.length > 0;
        if (hasImagesToUpload) {
            const invalidImage = uploadedDocument.some((file) => !file.type?.startsWith("image/"));
            if (invalidImage) {
                setImageSelectedError("Only image files, including GIF images, can be uploaded.");
                return;
            }
            if (selectedImageBytes > imageUploadLimitBytes) {
                showImageLimitDialog(
                    `Current and selected images total ${formatMegabytes(selectedImageBytes)} MB. The configured maximum is ${imageUploadLimitMb} MB.`
                );
                return;
            }

            setImageSelectedError("");
            setFormSubmitted(false);
            const imageEntries = uploadedDocument.map((file, index) => ({
                file,
                preview: selectedImage[index],
            }));
            await uploadProductImageEntries(imageEntries, [...existingProductImages]);
        } else {
            await handleSaveProduct([...existingProductImages]);
        }
    };

    const deleteInventory = async () => {
        try {
            setSnpLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}inventory-delete-v2?deleteId=${inventoryDetails.id}&token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cUrl);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveAction: "Create new!",
                    handleSubmit: () => {
                        getInventoryList(productInfo.prdId);
                        handleNewInvetory();
                    },
                    negativeAction: "Go back!", subTitle: "Inventory deleted successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });
            }
            setSnpLoader(false);
        } catch (error) {
            setSnpLoader(false);
            console.error("deleteInventory", inventoryDetails.id, error);
        }
    };

    const deleteProduct = async () => {
        try {
            setSnpLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}product-delete?deleteId=${productInfo.prdId}&token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cUrl);
            if (response.data.status === SUCCESS) {
                showDialog({
                    ...dialogConfig,
                    negativeReq: true,
                    positiveAction: "Create new!",
                    handleSubmit: () => {
                        setProductInfo(INITIAL_PRODUCT_INFO);
                        setListInventory([]);
                    },
                    negativeAction: "Go back!", subTitle: "Product deleted successfully",
                    handleClose: () => {
                        closeDialog();
                        navigate("/dashboard/showproduct");
                    },
                });

            }
            setSnpLoader(false);
        } catch (error) {
            setSnpLoader(false);
            console.error("deleteProduct", productInfo.prdId, error);
        }
    };

    const saveSuggestedItems = (listItemSuggestion) => {
        if (listItemSuggestion.length > 0) {
            setSuggAvail(true);
            setSuggestedItem(listItemSuggestion);
        }
    };

    const getProductDetails = async (e, optPage = 0, optTotal = 0) => {
        const { name, value } = e.target;
        setProductInfo(prev => ({
            ...prev,
            [name]: value,
        }))
        try {
            if (value && value.length > 2) {
                const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}show-user-product-data-v2?token=${getAuthSession().apiToken}&shopHash=${storeActiveShopHash.id}&stock=${value}&page=${optPage}&total=${optTotal}`;
                const response = await axios.get(cartUrl);
                if (response.data.status === SUCCESS) {
                    const payLoad = response.data.jcJson;
                    setListProduct(payLoad.value_2);
                } else {
                    setListProduct([]);
                }
            }
        } catch (error) {
            console.error("getProductDetails", value, optPage, optTotal, error);
            setListProduct([]);
        }
    };

    useEffect(() => {
        const mPrdInfo = productProps.productInfo || INITIAL_PRODUCT_INFO;
        if (!isEmpty(mPrdInfo.prdId)) {
            getInventoryList(mPrdInfo.prdId);
        }
        getCateogoryInventoryType();
        getProductImageUploadLimit();
        setProductInfo(mPrdInfo);
        setInventoryDetails(productProps.inventoryDetails || INITIAL_INVENTORY_DETAILS);
        setColor(productProps.color || INITIAL_COLOR_MODEL);
        setDialColor(productProps.dialColor || INITIAL_COLOR_MODEL);
        setConversionSingleData(productProps.conversionSingleData || INITIAL_CONVERSION_SINGLE_DATA);
        setSelectedcategory(productProps.selectedCategory || INITIAL_CATEOGORY_ITEM);
        saveSuggestedItems(productProps.listItemSuggestion || []);
    }, [storeActiveShopHash, storeApiUrl])

    useEffect(() => {
        let cancelled = false;
        const imagePaths = [...existingProductImages];

        if (imagePaths.length === 0) {
            setExistingImageSizes({});
            setExistingImageSizeError("");
            setExistingImageSizeLoading(false);
            return () => {
                cancelled = true;
            };
        }

        const loadExistingImageSizes = async () => {
            setExistingImageSizeLoading(true);
            setExistingImageSizeError("");
            const results = await Promise.allSettled(
                imagePaths.map(async (imagePath) => [imagePath, await getExistingProductImageSize(imagePath)])
            );
            if (cancelled) return;

            const nextSizes = {};
            const failedPaths = [];
            results.forEach((result, index) => {
                if (result.status === "fulfilled") {
                    nextSizes[result.value[0]] = result.value[1];
                } else {
                    failedPaths.push(imagePaths[index]);
                }
            });
            setExistingImageSizes(nextSizes);
            setExistingImageSizeLoading(false);
            if (failedPaths.length > 0) {
                setExistingImageSizeError(
                    `Could not calculate the size of ${failedPaths.length} existing image${failedPaths.length === 1 ? "" : "s"}. Please try again.`
                );
            }
        };

        loadExistingImageSizes();
        return () => {
            cancelled = true;
        };
    }, [existingProductImages, getExistingProductImageSize])

    return (
        <React.Fragment>
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <ThreeDText
                    text="Product Information"
                    display=""
                    className="three-d-text-container"
                    justifyContent="left"
                    alignItems="left" />
            </Grid>
            <Grid item xs={12}>
                <Paper elevation={10}
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#e6e7e8",
                        boxShadow: 1,
                        borderRadius: 4,
                        padding: 1,
                    }} ><Grid container spacing={1}>
                        <Grid item md={6} xs={12} sm={6} lg={6}>
                            {/* <TextField
                                required
                                id="prdName"
                                label="Enter Item Name"
                                name="prdName"
                                variant="filled"
                                size="small"
                                value={productInfo.prdName}
                                onChange={handleProductChange}
                                fullWidth
                                error={formSubmitted && productInfo.prdName === ""}
                                helperText={getErrorMessage('prdName')}
                            /> */}
                            <Autocomplete id="prdName"
                                freeSolo
                                disabled={productProps.isEditProduct}
                                options={listProduct}
                                autoHighlight
                                size="small"
                                variant="filled"
                                fullWidth
                                value={productInfo}
                                onChange={handleSelectProduct}
                                onBlur={(e) => setListProduct([])}
                                getOptionLabel={(option) => option ? option?.prdName : ''}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        key={option.id}
                                    >
                                        {uiUtilInstance.getProductLabel(option)}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="prdName"
                                        label="Search/Enter Product"
                                        onChange={(e) => getProductDetails(e)}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} xs={12} sm={6} lg={6}>
                            {/* <TextField
                                id="hsnCode"
                                name="hsnCode"
                                variant="filled"
                                size="small"
                                label="Enter HSN Code"
                                value={productInfo.hsnCode}
                                onChange={handleProductChange}
                                fullWidth
                            /> */}
                            <Autocomplete id="hsnCode"
                                freeSolo
                                disabled={productProps.isEditProduct}
                                options={listHsnCode}
                                autoHighlight
                                size="small"
                                name="hsnCode"
                                variant="filled"
                                fullWidth
                                value={productInfo.hsnCode}
                                onChange={(e, row) => handleSelectProductChild("hsnCode", row)}
                                onBlur={(e) => setListHsnCode([])}
                                getOptionLabel={(option) => option || ''}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="hsnCode"
                                        label={storeActiveShopHash.cartType === CartDets.Watch ? "Search/Enter Serial No" : "Search/Enter Hsn Code"}
                                        onChange={(e) => handleSearchHsnCodeBrandName(e, 2)}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} xs={12} sm={6} lg={6}>
                            {/* <TextField
                                required
                                id="brand-Name"
                                label="Enter Brand Name"
                                fullWidth
                                size="small"
                                name="brandName"
                                variant="filled"
                                value={productInfo.brandName}
                                onChange={handleProductChange}
                                error={formSubmitted && productInfo.brandName === ""}
                                helperText={getErrorMessage('brandName')}
                            /> */}
                            <Autocomplete id="brandName"
                                name="brandName"
                                freeSolo
                                disabled={productProps.isEditProduct}
                                options={listBrandName}
                                autoHighlight
                                size="small"
                                variant="filled"
                                fullWidth
                                value={productInfo.brandName}
                                onChange={(e, row) => handleSelectProductChild("brandName", row)}
                                onBlur={(e) => setListBrandName([])}
                                getOptionLabel={(option) => option || ''}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="brandName"
                                        label="Search/Enter Brand Name"
                                        onChange={(e) => handleSearchHsnCodeBrandName(e, 3)}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} sm={6} lg={6} xs={12} >
                            <Autocomplete
                                id="cateogory-select"
                                disabled={productProps.isEditProduct}
                                options={productProps.categoryData || []}
                                autoHighlight
                                onChange={handleSelectChange}
                                size="small"
                                variant="filled"
                                fullWidth
                                getOptionLabel={(option) => option.catgName}
                                value={selectedCategory}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option.catgName}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Choose a category"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <Autocomplete id="quick-select"
                                multiple
                                freeSolo
                                options={listComposition}
                                autoHighlight
                                size="small"
                                variant="filled"
                                fullWidth
                                value={productInfo.composition}
                                onChange={handleSelectComposition}
                                onBlur={(e) => setListComposition([])}
                                getOptionLabel={(option) => option || ''}
                                inputValue={inputValue}
                                onInputChange={handleItemSearchChange}
                                onKeyDown={handleKeyDownComposition}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                    >
                                        {option}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        name="composearch"
                                        label={storeActiveShopHash.cartType === CartDets.Pharma ? "Enter Composition" : "Enter SubCateogory/Tags"}
                                        onChange={handleSearchComposition}
                                        helperText="Use Enter/Tab/Comma(,) to add"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        {
                            storeActiveShopHash.cartType === CartDets.Pharma
                            &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <Autocomplete name="effect-select"
                                    multiple
                                    freeSolo
                                    options={listSideEffects}
                                    autoHighlight
                                    size="small"
                                    variant="filled"
                                    fullWidth
                                    value={productInfo.stockSideEffects}
                                    onChange={handleSelectSideEffect}
                                    onBlur={(e) => setListSideEffects([])}
                                    getOptionLabel={(option) => option || ''}
                                    inputValue={inputSideEffects}
                                    onInputChange={handleItemSearchChange}
                                    onKeyDown={handleKeyDownSideEffect}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            {...props}
                                        >
                                            {option}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            name="effectsearch"
                                            label={"Enter Side Effect"}
                                            onChange={handleSearchComposition}
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Pharma
                            && <Grid item md={6} sm={6} lg={6} xs={12}>
                                <Autocomplete name="usage-select"
                                    multiple
                                    freeSolo
                                    options={listStockUsage}
                                    autoHighlight
                                    size="small"
                                    variant="filled"
                                    fullWidth
                                    value={productInfo.stockUsage}
                                    onChange={handleSelectUsage}
                                    onBlur={(e) => setListStockUsage([])}
                                    getOptionLabel={(option) => option || ''}
                                    inputValue={inputUsageValue}
                                    onInputChange={handleItemSearchChange}
                                    onKeyDown={handleKeyDownUsage}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            {...props}
                                        >
                                            {option}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Enter Usage"
                                            name="usagesearch"
                                            onChange={handleSearchComposition}
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Pharma &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <TextField
                                    id="storage"
                                    name="stockStorage"
                                    variant="filled"
                                    size="small"
                                    label="Enter Therapeutic Class"
                                    value={productInfo.stockStorage}
                                    onChange={handleProductChange}
                                    fullWidth
                                />
                            </Grid>
                        }
                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <TextField
                                id="rack_no"
                                name="rack_no"
                                variant="filled"
                                size="small"
                                label="Enter Rack No(Location)"
                                value={productInfo.rack_no}
                                onChange={handleProductChange}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <div
                                className="about-item-launcher"
                                role="button"
                                tabIndex={0}
                                aria-label="Open About Item editor"
                                onClick={() => setAboutItemEditorOpen(true)}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter" || event.key === " ") {
                                        event.preventDefault();
                                        setAboutItemEditorOpen(true);
                                    }
                                }}
                            >
                                <TextField
                                    id="aboutItem"
                                    name="aboutItem"
                                    variant="filled"
                                    size="small"
                                    multiline={true}
                                    rows={3}
                                    maxRows={5}
                                    label="About Item (click to edit)"
                                    value={richTextValueToPlainText(productInfo.aboutItem)}
                                    fullWidth
                                    className="about-item-readonly-field"
                                    readOnly
                                    InputProps={{ readOnly: true }}
                                    inputProps={{ readOnly: true, tabIndex: -1 }}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Item Status</FormLabel>
                                <RadioGroup aria-label="itemStatus" name="itemStatus" value={productInfo.itemStatus} onChange={handleProductChange} row={true}>

                                    <FormControlLabel value={ItemStatus.ACTIVE} control={<Radio />} label="Active" />
                                    <FormControlLabel value={ItemStatus.INACTIVE} control={<Radio />} label="InActive" />

                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <ThreeDText
                    text="Inventory Details"
                    display=""
                    className="three-d-text-container"
                    justifyContent="left"
                    alignItems="left" />
            </Grid>
            <Grid item xs={12}>
                <Typography variant="p" component="div" style={{
                    color: "rgba(3, 56, 136, 0.88)", fontFamily: "monospace"
                    , whiteSpace: 'pre-wrap'
                    , overflowWrap: 'break-word'
                }} >Note: Any changes in field(Custom Unit , In-Person, Size, Color ) lead to be new entry as Inventory.If you want to edit then delete first</Typography>
            </Grid>
            {
                listInventory.length > 0 &&
                <Grid item xs={12}>
                    <Paper elevation={10}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            backgroundColor: "#a99a86",
                            boxShadow: 1,
                            borderRadius: 4,
                            padding: 1,
                        }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} >
                                <Grid container spacing={1}
                                    direction="row">
                                    {
                                        listInventory.length > 1 &&
                                        <Grid item md={6} sm={6} lg={6} xs={12}>
                                            <Autocomplete
                                                id="inv-select"
                                                size="small"
                                                options={listInventory || []}
                                                onChange={handleInventorySelect}
                                                fullWidth
                                                onBlur={() => setInputListInventory("")}
                                                inputValue={inputListINvetory}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onInputChange={handleInputListInventory}
                                                getOptionLabel={(option) => uiUtilInstance.getInventoryOptionLabel(option)}
                                                renderOption={(props, option) => (
                                                    <Box
                                                        component="li"
                                                        {...props}
                                                        key={option.id}
                                                        sx={{
                                                            border: "1px solid lightgrey", // light grey border
                                                            borderRadius: "4px",           // optional: rounded corners
                                                            padding: "1px",
                                                        }}
                                                    >
                                                        {uiUtilInstance.getInventoryOptionLabel(option)}
                                                    </Box>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label={`Select Inventory(Total:${listInventory.length})`}
                                                        inputProps={{
                                                            ...params.inputProps,
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    }
                                    {
                                        !isEmpty(inventoryDetails.id) &&
                                        <Grid item xs={12} md={6}>
                                            <SnpButton variant="contained" mbgcolor="#624634" onPointerDown={() => handleNewInvetory()}>
                                                {listInventory.length === 0 ? `Add new Entry` : `Add Entry no ${listInventory.length + 1}`}
                                            </SnpButton>
                                        </Grid>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            }
            <Grid item xs={12}>
                <Paper elevation={10}
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#e0d6d0",
                        boxShadow: 1,
                        borderRadius: 4,
                        padding: 1,
                    }} ><Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container spacing={1}>
                                <Grid item md={3} sm={4} lg={3} xs={12} sx={{ minWidth: 0 }}>
                                    <input
                                        accept="image/*,.gif"
                                        id="imgPath"
                                        name="imgPath"
                                        type="file"
                                        multiple
                                        onChange={handleInventoryChange}
                                        style={{ display: "none" }}
                                    />
                                    <label htmlFor="imgPath">
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            startIcon={<FileUploadIcon />}
                                            disabled={existingImageSizeLoading || Boolean(existingImageSizeError)}
                                            onClick={(event) => {
                                                if (isImageUploadFull) {
                                                    event.preventDefault();
                                                    showImageLimitDialog(
                                                        `Image limit is full (${formatMegabytes(selectedImageBytes)} MB of ${imageUploadLimitMb} MB used). Delete an image before adding another.`
                                                    );
                                                }
                                            }}
                                            style={{ textTransform: "none", borderRadius: "8px" }}
                                        >
                                            Upload Product Image
                                        </Button>
                                    </label>
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            display: "block",
                                            width: "100%",
                                            maxWidth: "100%",
                                            mt: 0.5,
                                            color: "#4b5563",
                                            lineHeight: 1.35,
                                            whiteSpace: "normal",
                                            overflowWrap: "anywhere",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {existingImageSizeLoading
                                            ? "Calculating current image size..."
                                            : `${formatMegabytes(selectedImageBytes)} MB used • ${formatMegabytes(remainingImageUploadMb)} MB remaining (${formatMegabytes(pendingImageBytes)} MB pending, ${imageUploadLimitMb} MB max)`}
                                    </Typography>
                                </Grid>
                                {
                                    selectedImage && selectedImage.length > 0 &&
                                    selectedImage.map((item, index) => (
                                        <Card orientation="horizontal" size="md" key={"Pending_Image_" + index} variant="outlined">
                                            <img
                                                alt={"Image_" + index}
                                                style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                                                // src={storeApiUrl.BACKEND_BASE_URL + "files/" + imgv}
                                                src={item}
                                            />
                                            <DeleteIcon
                                                onClick={() => handleDeleteInternalImage(index)} />

                                        </Card>

                                    ))
                                }
                                {
                                    existingProductImages.length > 0 && existingProductImages.map((item, index) => (
                                        <Card orientation="horizontal" size="md" key={"Saved_Image_" + index} variant="outlined">
                                            <img
                                                style={{ height: "80px", width: "80px", borderRadius: "40%" }}
                                                srcSet={`${storeApiUrl.BACKEND_BASE_URL + "files/" + item}`}
                                                src={`${storeApiUrl.BACKEND_BASE_URL + "files/" + item}`}
                                                alt={"Image_" + index}
                                            />
                                            {
                                                existingProductImages.length > 1 && <DeleteIcon
                                                    onClick={() => handleDeleteImage(index)} />
                                            }

                                        </Card>

                                    ))
                                }
                            </Grid>
                        </Grid>
                        {existingImageSizeError &&
                            <Grid container sx={{ mb: 1 }}>
                                <Grid item xs zeroMinWidth>
                                    <Typography variant="body2" color="#EE4B2B" sx={{ whiteSpace: "normal", overflowWrap: "anywhere" }}>
                                        {existingImageSizeError}
                                    </Typography>
                                </Grid>
                            </Grid>
                        }
                        {imageSelectedError &&
                            <Grid container sx={{
                                mb: 1,
                            }}>
                                <Grid item xs zeroMinWidth>
                                    <Typography variant="body2" color="#EE4B2B" sx={{ whiteSpace: "normal", overflowWrap: "anywhere" }}>
                                        {imageSelectedError}
                                    </Typography>
                                </Grid></Grid>

                        }
                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <Autocomplete
                                id="cnv-select"
                                size="small"
                                disabled={!isEmpty(inventoryDetails.id) && (productProps.isEditProduct || false)}
                                options={productProps.conversionTypeData || []}
                                onChange={handleConversionChange}
                                fullWidth
                                getOptionLabel={(option) => option?.cnvDetails || ''}
                                value={conversionSingleData}
                                renderOption={(props, option) => (
                                    <Box
                                        component="li"
                                        {...props}
                                        sx={{
                                            border: "1px solid lightgrey", // light grey border
                                            borderRadius: "4px",           // optional: rounded corners
                                            padding: "1px",
                                            ...(option.id === 'cr' && {
                                                background: '#0770c1',
                                                fontWeight: 'bold',
                                                '&:hover': {
                                                    background: '#0770c1', // keep same on hover
                                                },
                                            }),
                                        }}
                                    >
                                        {option?.cnvDetails}
                                    </Box>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Custom Unit Type"
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        {
                            createUnit &&
                            <Grid item xs={12}>
                                <Grid container spacing={1} justifyContent="center"
                                    alignItems="center">
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <TextField
                                            required
                                            id="unitName"
                                            label="Enter Unit Name"
                                            name="unitName"
                                            variant="filled"
                                            size="small"
                                            value={conversionSingleData.unitName}
                                            onChange={handleCoversionUpdate}
                                        />
                                    </Grid>
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <FormControlLabel control={<Checkbox checked={conversionSingleData.unitRestrictions}
                                            onChange={handleCoversionUpdate} id="unitRestrictions" />} name="unitRestrictions" label="Unit Restrictions" />
                                    </Grid>
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <TextField
                                            required
                                            id="smallUnitCount"
                                            variant="filled"
                                            size="small"
                                            label="Enter Small Unit Count"
                                            name="smallUnitCount"
                                            value={conversionSingleData.smallUnitCount}
                                            onChange={handleCoversionUpdate}
                                        />
                                    </Grid>
                                    <Grid item md={6} sm={6} lg={6} xs={12}>
                                        <TextField
                                            required
                                            variant="filled"
                                            size="small"
                                            id="smallUnitName"
                                            label="Enter Small Unit Name"
                                            name="smallUnitName"
                                            value={conversionSingleData.smallUnitName}
                                            onChange={handleCoversionUpdate}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel control={<Checkbox checked={conversionSingleData.decimalSmRestrictions}
                                            onChange={handleCoversionUpdate} id="decimalSmRestrictions" />} name="decimalSmRestrictions"
                                            label=
                                            {<p>Disable Fraction{"(Eg."} <span style={{ textDecoration: "line-through" }}> 0.5 {conversionSingleData.unitName}</span>{" 5 " + conversionSingleData.smallUnitName + " )"}</p>}

                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        <Grid item md={6} sm={6} lg={6} xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select below</FormLabel>
                                <RadioGroup
                                    aria-label="personType"
                                    name="personType"
                                    value={inventoryDetails.personType}
                                    onChange={handleInventoryChange}
                                    row={true}
                                >
                                    {Object.entries(PersonType).map(([key, value]) => (
                                        <FormControlLabel
                                            key={key}
                                            value={value}
                                            control={<Radio />}
                                            label={uiUtilInstance.formatLabel(value)}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <TextField
                                    id="caseMetal"
                                    name="caseMetal"
                                    variant="filled"
                                    size="small"
                                    label="Enter Case Metal"
                                    value={inventoryDetails.caseMetal}
                                    onChange={handleInventoryChange}
                                    fullWidth
                                />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <TextField
                                    id="caseSize"
                                    name="caseSize"
                                    variant="filled"
                                    size="small"
                                    label="Enter Case Size"
                                    value={inventoryDetails.caseSize}
                                    onChange={handleInventoryChange}
                                    fullWidth
                                />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <TextField
                                    id="lugWidth"
                                    name="lugWidth"
                                    variant="filled"
                                    size="small"
                                    label="Enter Lug Width"
                                    value={inventoryDetails.lugWidth}
                                    onChange={handleInventoryChange}
                                    fullWidth
                                />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <TextField
                                    id="jewels"
                                    name="jewels"
                                    variant="filled"
                                    size="small"
                                    label="Enter Jewels"
                                    value={inventoryDetails.jewels}
                                    onChange={handleInventoryChange}
                                    fullWidth
                                />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Select Item Condition</FormLabel>
                                    <RadioGroup
                                        aria-label="condition"
                                        name="condition"
                                        value={inventoryDetails.condition}
                                        onChange={handleInventoryChange}
                                        row={true}
                                    >
                                        {Object.entries(ItemCondtion).map(([key, value]) => (
                                            <FormControlLabel
                                                key={key}
                                                value={value}
                                                control={<Radio />}
                                                label={uiUtilInstance.formatLabel(key)}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        }
                        {
                            (subCatgList && subCatgList.length > 0 && storeActiveShopHash.cartType === CartDets.Watch) &&
                            <Grid item md={6} sm={6} lg={6} xs={12}>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Select Watch Movement Type</FormLabel>
                                    <RadioGroup
                                        aria-label="movementType"
                                        name="movementType"
                                        value={inventoryDetails.movementType}
                                        onChange={handleInventoryChange}
                                        row={true}
                                    >
                                        {subCatgList.map((value) => (
                                            <FormControlLabel
                                                key={value}
                                                value={value}
                                                control={<Radio />}
                                                label={value}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        }
                        <Grid item md={12} sm={12} lg={12} xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Size</FormLabel>
                                <RadioGroup
                                    aria-label="sizeType"
                                    name="sizeType"
                                    value={inventoryDetails.sizeType}
                                    onChange={handleInventoryChange}
                                    row={true}
                                >
                                    {Object.entries(SizeType).map(([key, value]) => (
                                        <FormControlLabel
                                            key={key}
                                            value={value}
                                            control={<Radio />}
                                            label={value}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item xs={12}>
                                <FormControlLabel control={<Checkbox checked={inventoryDetails.waterResistance}
                                    onChange={handleInventoryChange} id="waterResistance" />} name="waterResistance" label="Water Resistance" />
                            </Grid>
                        }
                        {
                            storeActiveShopHash.cartType === CartDets.Watch &&
                            <Grid item xs={6}>
                                <Autocomplete
                                    id="search-dial-color"
                                    name="dial-color"
                                    options={listDialColor}
                                    autoHighlight
                                    variant="filled"
                                    size="small"
                                    fullWidth
                                    value={dialColor}
                                    onChange={handleDialColor}
                                    onBlur={(e) => setListDialColor([])}
                                    isOptionEqualToValue={(option, value) => option?.colorId === value?.colorId}
                                    getOptionLabel={(option) => option?.colorDetails || ''}
                                    renderOption={(props, option) => (
                                        <li {...props} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <div
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: option.colorDetails.split(" ")[0],
                                                    border: "1px solid #ccc",
                                                    borderRadius: 4,
                                                }}
                                            />
                                            {option.colorDetails}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Search Dial Color"
                                            name="dial-color"
                                            onChange={handleSearchColor}
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }
                        <Grid item xs={6}>
                            <Autocomplete
                                id="search-color"
                                name="search color"
                                options={listColor}
                                autoHighlight
                                variant="filled"
                                size="small"
                                fullWidth
                                value={color}
                                onChange={handleSelectColorChange}
                                onBlur={(e) => setListColor([])}
                                isOptionEqualToValue={(option, value) => option?.colorId === value?.colorId}
                                getOptionLabel={(option) => option?.colorDetails || ''}
                                renderOption={(props, option) => (
                                    <li {...props} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <div
                                            style={{
                                                width: 20,
                                                height: 20,
                                                backgroundColor: option.colorDetails.split(" ")[0],
                                                border: "1px solid #ccc",
                                                borderRadius: 4,
                                            }}
                                        />
                                        {option.colorDetails}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={storeActiveShopHash.cartType === CartDets.Watch ? "Search Straps Color" : "Search Color"}
                                        name="search-color"
                                        onChange={handleSearchColor}
                                        inputProps={{
                                            ...params.inputProps,
                                        }}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <FormLabel component="legend">Select Inventory Status</FormLabel>
                                <RadioGroup aria-label="itemStatus" name="itemStatus" value={inventoryDetails.itemStatus} onChange={handleInventoryChange} row={true}>

                                    <FormControlLabel value={ItemStatus.ACTIVE} control={<Radio />} label="Active" />
                                    <FormControlLabel value={ItemStatus.INACTIVE} control={<Radio />} label="InActive" />

                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        {
                            isEmpty(inventoryDetails.id) &&
                            <Grid item xs={12}>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={2} // gap between A, switch, and B
                                    sx={{
                                        width: "100%",
                                        justifyContent: "center", // center horizontally
                                    }}
                                >
                                    {/* Left Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 600,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        AI based Update
                                    </Typography>

                                    {/* Switch */}
                                    <Switch
                                        color="primary"
                                        checked={createNewInventory}
                                        onChange={(e) => setCreateNewInventory(e.target.checked)}
                                        inputProps={{ "aria-label": "dark mode" }}
                                    />

                                    {/* Right Label */}
                                    <Typography
                                        sx={{
                                            fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                                            fontWeight: 600,
                                            whiteSpace: 'pre-wrap'
                                            , overflowWrap: 'break-word'
                                        }}
                                    >
                                        Create as new entry
                                    </Typography>
                                </Stack>


                            </Grid>
                        }
                        {
                            inventoryDetails.allowedDelete &&
                            <Grid item xs={12}>
                                <SnpButton variant="contained" color="bRed" onPointerDown={() => deleteInventory()}>
                                    Delete Inventory
                                </SnpButton>
                            </Grid>
                        }
                        {
                            !isEmpty(inventoryDetails.id) &&
                            <Grid item xs={6}>
                                <SnpButton variant="contained" mbgcolor="#0073ae" onPointerDown={() => {
                                    if (isFeatureAllowed(STOCKMGMT) && isRoleAllowed(STOCKMGMT, ROLE_VIEW)) {
                                        navigate("/dashboard/stockentry", { state: { prdId: inventoryDetails.id, isEditStock: 1 } });
                                    } else {
                                        showDialog({
                                            ...dialogConfig,
                                            negativeReq: true,
                                            negativeAction: "Ok Got it!",
                                            subTitle: "You Are not allowed to Add/Update Stock Details.Contact the Owner",
                                            handleClose: closeDialog,
                                        });
                                    }
                                }}>
                                    Create Stock
                                </SnpButton>
                            </Grid>
                        }
                        {
                            !isEmpty(inventoryDetails.id) && !inventoryDetails.allowedDelete &&
                            <Grid item xs={6}>
                                <SnpButton variant="contained" mbgcolor="#009fae" onPointerDown={() => {
                                    if (isFeatureAllowed(STOCKMGMT) && isRoleAllowed(STOCKMGMT, ROLE_VIEW)) {
                                        navigate("/dashboard/stockentry", { state: { prdId: inventoryDetails.id, isEditStock: 0 } });
                                    } else {
                                        showDialog({
                                            ...dialogConfig,
                                            negativeReq: true,
                                            negativeAction: "Ok Got it!",
                                            subTitle: "You Are not allowed to Add/Update Stock Details.Contact the Owner",
                                            handleClose: closeDialog,
                                        });
                                    }
                                }}>
                                    Check Stock
                                </SnpButton>
                            </Grid>
                        }
                    </Grid>
                </Paper>
            </Grid>
            {
                isFeatureAllowed(CUSTOMERAPP)
                && <Grid item xs={12}>
                    <Autocomplete id="suggestion-select"
                        multiple
                        freeSolo
                        options={itemData}
                        limitTags={2}
                        autoHighlight
                        size="small"
                        variant="filled"
                        fullWidth
                        value={suggestedItem}
                        onChange={(event, newValue, reason, detail) => {
                            printDebugLog("Autocomplete", newValue, reason);
                            setInputValue('');
                            if (suggestionAvail) {
                                if (reason === 'removeOption') {
                                    const updatedItems = [...suggestedItemDeleted, detail.option.id];
                                    setSuggestedItemDeleted(updatedItems);
                                } else if (reason === 'selectOption') {
                                    if (suggestedItemDeleted.length > 0) {
                                        const idToDelete = detail.option.id;
                                        const indexToDelete = suggestedItemDeleted.findIndex(item => item === idToDelete);
                                        // If item is found, create a new array without it
                                        if (indexToDelete !== -1) {
                                            const updatedItems = [...suggestedItemDeleted.slice(0, indexToDelete), ...suggestedItemDeleted.slice(indexToDelete + 1)];
                                            setSuggestedItemDeleted(updatedItems);
                                        }
                                    }
                                } else if (reason === 'clear') {
                                    suggestedItem.forEach(element => {
                                        const updatedItems = [...suggestedItemDeleted, element.id];
                                        setSuggestedItemDeleted(updatedItems);
                                    });
                                }
                            }
                            setSuggestedItem(newValue);
                        }}
                        onBlur={(e) => setItemData([])}
                        getOptionLabel={(option) => option?.details || ''}
                        inputValue={inputValue}
                        onInputChange={handleInputChangeValue}
                        filterOptions={(options, { inputValue }) =>
                            options.filter((option) =>
                                option.details?.toLowerCase().includes(inputValue.toLowerCase()) ||
                                option.prdType?.toLowerCase().includes(inputValue.toLowerCase()) ||
                                option.tags?.toLowerCase().includes(inputValue.toLowerCase()) ||
                                option.catgName?.toLowerCase().includes(inputValue.toLowerCase())
                            )
                        }
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                {...props}
                            >
                                {uiUtilInstance.getStockOptionLabel(option)}
                            </Box>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Add Item Suggestion"
                                placeholder="Search"
                                onChange={handleSearch}
                                inputProps={{
                                    ...params.inputProps,
                                }}
                            />
                        )}
                    />
                </Grid>
            }
            <Grid item xs={12} md={6} sm={6} lg={6}>
                <SnpButton variant="contained" mbgcolor={(productProps.isEditProduct || false) ? "#764032" : "#01333e"} onPointerDown={() => handleImageUpload()}>
                    {!isEmpty(productInfo.prdId) ? "Update" : "Create"}
                </SnpButton>
            </Grid>
            <Grid item xs={12} md={6} sm={6} lg={6}>
                <DismissButton variant="contained" onPointerDown={() => navigate("/dashboard/showproduct")}>
                    Dismiss
                </DismissButton>
            </Grid>
            {
                listInventory.length === 0 && !isEmpty(productInfo.prdId) &&
                <Grid item xs={12}>
                    <SnpButton variant="contained" color="bRed" onPointerDown={() => deleteProduct()}>
                        Delete Product
                    </SnpButton>
                </Grid>
            }
        </Grid>
        <AboutItemEditor
            open={aboutItemEditorOpen}
            value={productInfo.aboutItem}
            onClose={() => setAboutItemEditorOpen(false)}
            onSave={(aboutItem) => {
                setProductInfo((previous) => ({ ...previous, aboutItem }));
                setAboutItemEditorOpen(false);
            }}
        />
        </React.Fragment>
    )
};
export default React.memo(AddProduct);
